import { isCIImageOpenSource } from "@/domain/scan-history"
import { ImageIcon, SourceControlIcon } from "@/icons"

import type { ScanHistory } from "@/domain/scan-history"

export const IconResourceCell = ({
  record,
  className
}: {
  record: ScanHistory
  className?: string
}) => {
  if (isCIImageOpenSource(record))
    return <ImageIcon hideTooltip imageSource="local" className={className} />

  return (
    <SourceControlIcon
      hideTooltip
      sourceControl={record.sourceControl}
      className={className}
    />
  )
}
